import React from "react";
import ListWithIcon from "./ListWithIcon";
import Button from "./Button";
import { CheckCircle } from "lucide-react";
import { motion } from "framer-motion";

const GridComp = ({
  title,
  highlight = "",
  paragraphs = [],
  listItems = [],
  bullets = [],
  buttons = [],
  image = null,
  align = "left",
  reverse = false,
  titleColor = "text-white",
  highlightColor = "text-[#ffa121]",
}) => {
  const alignMap = {
    left: "items-start text-left",
    center: "items-center text-center",
    right: "items-end text-right",
  };

  // Motion Variants
  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <section className="w-full h-auto">
      {/* Parent motion wrapper */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.3 }}
        className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${
          reverse ? "md:flex-row-reverse" : ""
        }`}
      >
        {/* Content */}
        <motion.div
          variants={fadeUp}
          className={`bg-white/20 backdrop-blur-md rounded-2xl lg:p-6 flex flex-col ${alignMap[align]} ${
            reverse ? "order-2" : "order-1"
          }`}
        >
          <h1
            className={`text-3xl lg:text-5xl font-bold leading-snug ${titleColor}`}
          >
            {title} <span className={highlightColor}>{highlight}</span>
          </h1>

          {paragraphs.length > 0 && (
            <div className="mt-4 space-y-3">
              {paragraphs.map((para, idx) => (
                <p key={idx} className={`${titleColor} leading-relaxed`}>
                  {para}
                </p>
              ))}
            </div>
          )}

          {bullets.length > 0 && (
            <ListWithIcon
              items={bullets}
              icon={CheckCircle}
              size="lg"
              layout="verticle"
              iconColor="text-green-600"
              variant="soft"
              iconBg="bg-green-50"
              className="my-6"
            />
          )}

          {buttons?.length > 0 && (
            <div className="mt-6 flex flex-col md:flex-row gap-4">
              {buttons.map((btn, idx) => (
                <Button
                  key={idx}
                  text={btn.label}
                  to={btn.link}
                  size="lg"
                  bgGradient={
                    btn.type === "primary"
                      ? "bg-gradient-to-r from-green-400 to-green-600"
                      : "bg-white text-blue-600"
                  }
                />
              ))}
            </div>
          )}
        </motion.div>

        {/* Image */}
        {image && (
          <motion.div
            variants={fadeUp}
            className={`flex justify-center items-end ${
              reverse ? "order-1" : "order-2"
            }`}
          >
            <img
              src={image}
              alt="Hero Illustration"
              className="h-auto w-auto object-contain drop-shadow-2xl"
            />
          </motion.div>
        )}
      </motion.div>
    </section>
  );
};

export default GridComp;
